require('../../modules/es6.object.get-own-property-names');
var $Object = require('../../modules/_core').Object;
module.exports = function getOwnPropertyNames(it) {
  return $Object.getOwnPropertyNames(it);
};



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.1@core-js/library/fn/object/get-own-property-names.js
// module id = 83
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/.2.5.1@core-js/library/fn/object/get-own-property-names.js